<template lang="pug">
v-card
  v-card-text
    v-layout.flex-column-phablet(justify-space-between, align-center)
      v-switch.ml-2(
        :label='data.enabled ? "Ingeschakeld" : "Uitgeschakeld"',
        v-model='data.enabled',
        style='max-width: 150px',
        color='primary'
        )

      v-btn(flat, small, :href='testFormUrl', target='_blank', v-if='!isNew') Bekijk voorbeeld
        v-icon.ml-1(small) fa fa-external-link-alt

    v-divider.mb-4

    v-layout.ml-3.mr-3.mt-3.flex-column-phablet(justify-space-between, align-center)
      text-field.small(
        v-model.number='data.ratePercentage',
        suffix='%',
        style='width:100px',
        label='Rentepercentage',
        type='number',
        min='0',
        required,
        :error-messages='ratePercentageValidationErrors',
        @change='$v.data.ratePercentage.$touch()',
        @blur='$v.data.ratePercentage.$touch()'
        )

      v-layout.mr-4(column)
        label: b Standaard looptermijn
        v-select(
          v-model='data.defaultNper',
          :items='nperItems',
          solo
          )

      v-layout(column)
        text-field(
          v-model.number='data.defaultFv',
          label='Standaard slottermijn',
          prefix='€',
          style='width:200px',
          type='number',
          min='0',
          required,
          :error-messages='defaultFvValidationErrors',
          @change='$v.data.defaultFv.$touch()',
          @blur='$v.data.defaultFv.$touch()'
          )
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { nperItems } from 'dealerfinanceservices-shared/src/helpers/constants'

export default {
  props: {
    value: Object,
    lease: String
  },

  data () {
    return {
      data: this.value,
      website: {},
      nperItems
    }
  },

  computed: {
    isBusinessLease () {
      return this.lease === 'businessLease'
    },

    isNew () {
      return this.$route.params.websiteId === 'new'
    },

    testFormUrl () {
      const image = 'https://portal-test.dealerfinanceservices.nl/images/example-car.jpg'
      const title = 'BMW-4'

      const urlType = this.isBusinessLease ? 'zakelijk' : 'particulier'

      return `${process.env.VUE_APP_FORM_DOMAIN}/lease/${urlType}?domain=${this.website.domain}&leasebedrag=10000&slottermijn=2000&looptijd=60&aanbetaling=1000&titel=${title}&afbeelding=${image}`
    },

    ratePercentageValidationErrors () {
      const errors = []
      if (!this.$v.data.ratePercentage.$dirty) return errors
      !this.$v.data.ratePercentage.required && errors.push('Dit veld is verplicht')
      return errors
    },

    defaultFvValidationErrors () {
      const errors = []
      if (!this.$v.data.defaultFv.$dirty) return errors
      !this.$v.data.defaultFv.required && errors.push('Dit veld is verplicht')
      return errors
    }
  },

  methods: {
    emitValid () {
      let valid = !this.$v.$invalid

      if (!this.data.enabled) valid = true

      this.$emit('valid', {
        lease: this.lease,
        valid
      })
    }
  },

  async created () {
    if (!this.isNew) {
      this.website = await this.$store.dispatch('graphqlQuery', {
        name: 'getWebsite',
        variables: {
          id: this.$route.params.websiteId
        }
      })
    }
  },

  watch: {
    value (v) {
      this.data = v
    },

    data: {
      handler: function (v) {
        this.$emit('input', this.data)
      },
      deep: true
    },

    '$v.$invalid': {
      handler: function (v) {
        this.emitValid()
      },
      immediate: true
    },

    'data.enabled': function (v) {
      this.emitValid()
    }
  },

  validations: {
    data: {
      ratePercentage: {
        required
      },

      defaultFv: {
        required
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.dialog-pricing {
  table {
    width: 100%;
    margin-bottom: $g;

    td {
      border-bottom: 1px solid $gray4;
    }
  }
}
</style>
